/* ============================================================================
   Nootrópicos México v71.60R7 — ProveSource real close button
   Seguro: sin MutationObserver y sin setInterval.

   Por qué existe:
   - La burbuja de ProveSource convierte casi toda el área en enlace.
   - CSS puede mostrar “Cerrar”, pero necesitamos un botón real que intercepte
     touch/click y cierre el popup sin abrir el enlace.
   ============================================================================ */
(function () {
  'use strict';

  var BTN_ID = 'nmProveSourceCloseBtn';
  var CLOSED_KEY = 'nm_provesource_closed_session';
  var retryDelays = [150, 500, 1000, 2000, 4000, 7000];

  function safePrevent(event) {
    if (!event) return;
    if (event.cancelable !== false && event.preventDefault) event.preventDefault();
    if (event.stopPropagation) event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }

  function getPoint(event) {
    if (!event) return null;
    if (typeof event.clientX === 'number') return { x: event.clientX, y: event.clientY };
    if (event.touches && event.touches[0]) return { x: event.touches[0].clientX, y: event.touches[0].clientY };
    if (event.changedTouches && event.changedTouches[0]) return { x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY };
    return null;
  }

  function getContainer() {
    return document.getElementById('provesrc-notification-container');
  }

  function getWidgetArea() {
    return document.getElementById('provesrc-widget-area');
  }

  function getBubble(container) {
    if (!container) return null;
    return container.querySelector('.bubble-content') || container.querySelector('[class*="bubble"]') || container;
  }

  function setClosedClass() {
    document.documentElement.classList.add('nm-ps-closed');
  }

  function wasClosed() {
    try { return sessionStorage.getItem(CLOSED_KEY) === '1'; }
    catch (err) { return document.documentElement.classList.contains('nm-ps-closed'); }
  }

  function markClosed() {
    try { sessionStorage.setItem(CLOSED_KEY, '1'); } catch (err) {}
    setClosedClass();
  }

  function hardHide() {
    var container = getContainer();
    var widget = getWidgetArea();
    var btn = document.getElementById(BTN_ID);

    [container, widget, btn].forEach(function (el) {
      if (!el || !el.style) return;
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('opacity', '0', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
    });

    if (container) container.setAttribute('aria-hidden', 'true');
    if (widget) widget.setAttribute('aria-hidden', 'true');
  }

  function closePopup(event) {
    safePrevent(event);
    markClosed();
    hardHide();
    return false;
  }

  function isCloseTarget(event) {
    var target = event && event.target;
    if (target && target.closest && target.closest('#' + BTN_ID)) return true;

    var btn = document.getElementById(BTN_ID);
    if (!btn || !btn.getBoundingClientRect) return false;

    var point = getPoint(event);
    if (!point) return false;

    var rect = btn.getBoundingClientRect();
    return point.x >= rect.left && point.x <= rect.right && point.y >= rect.top && point.y <= rect.bottom;
  }

  function ensureButton() {
    if (wasClosed()) {
      setClosedClass();
      hardHide();
      return;
    }

    var container = getContainer();
    var bubble = getBubble(container);
    if (!container || !bubble) return;

    var btn = document.getElementById(BTN_ID);
    if (!btn) {
      btn = document.createElement('button');
      btn.id = BTN_ID;
      btn.type = 'button';
      btn.setAttribute('aria-label', 'Cerrar notificación de compra');
      btn.textContent = '× Cerrar';

      ['touchstart', 'pointerdown', 'mousedown', 'click'].forEach(function (type) {
        btn.addEventListener(type, closePopup, { capture: true, passive: false });
      });
    }

    if (btn.parentNode !== bubble) {
      try { bubble.insertBefore(btn, bubble.firstChild); }
      catch (err) { bubble.appendChild(btn); }
    }

    /* El contenedor ya existe: avisa al controlador único para que aplique el
       dock exacto incluso si ProveSource apareció después de sus reintentos. */
    try { document.dispatchEvent(new CustomEvent('nm:provesource-ready')); }
    catch (err) { document.dispatchEvent(new Event('nm:provesource-ready')); }
  }

  function captureCloseZone(event) {
    ensureButton();
    if (isCloseTarget(event)) closePopup(event);
  }

  /* Captura en window + document para ganarle al enlace interno de ProveSource. */
  ['touchstart', 'pointerdown', 'mousedown', 'click'].forEach(function (type) {
    window.addEventListener(type, captureCloseZone, { capture: true, passive: false });
    document.addEventListener(type, captureCloseZone, { capture: true, passive: false });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureButton, { once: true });
  } else {
    ensureButton();
  }

  window.addEventListener('load', ensureButton, { once: true });
  window.addEventListener('pageshow', ensureButton);
  document.addEventListener('visibilitychange', ensureButton);

  retryDelays.forEach(function (delay) {
    window.setTimeout(ensureButton, delay);
  });
})();
